<form [formGroup]="addBoardForm" (ngSubmit)="addToBoard()">
    <table class="center-table" cellspacing="0">
        <tr>
            <td>
                <mat-form-field class="center-table" appearance="fill">
                    <mat-label>รหัสสินค้า</mat-label>
                    <input matInput formControlName="barcode" autofocus>
                </mat-form-field>
            </td>
            <td>
                <mat-form-field class="center-table" appearance="fill">
                    <mat-label>ชื่อสินค้า</mat-label>
                    <input matInput type="text" formControlName="name">
                </mat-form-field>
            </td>
            <td>
                <button mat-raised-button type="submit" color="primary">เพิ่ม</button>
            </td>
        </tr>
    </table>
</form>
<div class="example-boundary">
    <div class="example-box" cdkDragBoundary=".example-boundary" cdkDrag *ngFor="let element of boards;">
        <mat-icon (click)="deleteItem(element.id)" style="cursor: pointer;">delete</mat-icon>
        <ngx-barcode [bc-value]="element.barcode" [bc-display-value]="true" [bc-height]="50"></ngx-barcode>
        <p class="text-in-box">{{element.name}}</p>
    </div>
</div>